export default {
  path: '/',
  name: 'member',
  component: () => import('@/layouts/BaseLayout'),
  children: [
    {
      path: 'member',
      meta: { title: '会员列表', permission: 'member' },
      component: () => import('@/views/member/MemberList'),
    },
    {
      path: 'member-type',
      meta: { title: '会员类型', permission: 'member-type' },
      component: () => import('@/views/member/Member'),
    },
    {
      path: 'member-buyLog',
      meta: { title: '会员充值记录', permission: 'member-buyLog' },
      component: () => import('@/views/member/buyLog'),
    },
  ],
}